import { useCallback, useEffect, useState } from "react";
import { fetchAvailability } from "../lib/api";

export function useBookingAvailability(date, service, guests) {
  const key = `${date}:${service}:${guests}`;
  const [version, setVersion] = useState(0);
  const [state, setState] = useState({ key: "", data: null, loading: false, error: null });
  const retry = useCallback(() => setVersion((v) => v + 1), []);
  useEffect(() => {
    if (!date) return;
    const controller = new AbortController();
    let active = true;
    setState({ key, data: null, loading: true, error: null });
    fetchAvailability(date, service, guests, controller.signal)
      .then((data) => {
        if (active) setState({ key, data, loading: false, error: null });
      })
      .catch((error) => {
        if (active) setState({ key, data: null, loading: false, error });
      });
    return () => { active = false; controller.abort(); };
  }, [date, service, guests, key, version]);
  useEffect(() => {
    if (!date) return;
    const timer = setInterval(retry, 60000);
    window.addEventListener("focus", retry);
    window.addEventListener("online", retry);
    return () => {
      clearInterval(timer);
      window.removeEventListener("focus", retry);
      window.removeEventListener("online", retry);
    };
  }, [date, retry]);
  const current = state.key === key;
  return {
    availability: current ? state.data : null,
    loading: !!date && (!current || state.loading),
    error: current ? state.error : null,
    ready: !!date && current && !!state.data && !state.loading && !state.error,
    retry,
  };
}